import {FC} from 'react';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {DelayRow} from './DelayRow';

interface ITableBodyContainer {
  rowsPerPage: number;
  rows: any[];
  page: number;
}

export const TableBodyContainer: FC<ITableBodyContainer> = ({rowsPerPage, rows, page}) => {
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = rowsPerPage - rows.length;

  return (
    <TableBody>
      {rows.map((row, index) => {
        return <DelayRow key={row.date + row.id} row={row} id={page * rowsPerPage + index + 1} />;
      })}
      {emptyRows > 0 && (
        <TableRow
          style={{
            height: 63.09 * emptyRows,
          }}
        >
          <TableCell align="center" colSpan={5}>
            {emptyRows === rowsPerPage && 'Ничего не найдено'}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};
